import React, { useContext, useState } from "react";
import Column from "../../../../components/DataTable/models/Column";
import { LinkText } from "../../../../components/Common/hyperlinks";
import VerifyRow from "../models/VerifyRow";
import { VerifyUrls } from "../../index";
import { Checkbox, Tooltip, withStyles } from "@material-ui/core";
import FavCheckbox from "../../FavouritingAudits";
import  auditSharingPermission from "../../../../../src/Enums/AuditSharingPermission";
import { IconButton } from "@material-ui/core";
import downloadCertificate from "../../http/downloadCertificate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { dispatch } from "../../../../components/App/App";
import setError from "../../../../store/error/actions/setError";
import VerifyPDFToolTip from "../../../../Enums/VerifyPDFToolTip";
import { Link } from "react-router-dom";
import { upgradeToProText } from "../../../../constants/ToolTipsText";
import PDFTooltip from "../../../../components/Tooltips/pdfToolTip";
import { getUserId, isCBCommercialHorizonUser, isCBUser, isMegatronProUser } from "../../../../Authentication/Auth";
import { trackEvent } from "../../../../util/googletagmanager/GTM";
 const megatronProUser = getUserId() != undefined &&  isMegatronProUser() ;
  const VerifyTable = (megatronLiteUser: boolean): Column<VerifyRow>[] => {
    const columnsNotForCBs : Column<VerifyRow>[] =[
      {
        title: "Favourites",
        field: "IsFavourited",
        render: (rowData: VerifyRow) =>
          (rowData.SharingPermissionName ===
            auditSharingPermission.CertificateOnly ||
            rowData.SharingPermissionName ===
              auditSharingPermission.CertificatePDF) &&
          !megatronLiteUser ? (
            <FavCheckbox id={rowData.Id} fav={rowData.IsFavourited} />
          ) : megatronLiteUser ||
            rowData.SharingPermissionName ===
              auditSharingPermission.CertificateOnly ||
            rowData.SharingPermissionName ===
              auditSharingPermission.CertificatePDF ? (
            <PDFTooltip title={upgradeToProText}>
              <input
                type="checkbox" 
                onMouseEnter={()=>{
                                                if(megatronLiteUser)
                                                  {
                                             trackEvent('Feature_Interaction',{
                                              User_Role:"Company user Lite",
                                              Tab_Section:"Certificate Tracker",
                                              Type:"Checkbox/Hover message",
                                              Feature_Function:"Export list-Pro feature (blocked)",
                                              UserInput:"Checkbox/Hover message"})
                                                  }
                                                }
                                              }
                
          
                style={{
                  transform: "scale(1.5)",
                  marginLeft: "20px",
                  cursor: "not-allowed",
                }}
                disabled
              />
            </PDFTooltip>
          ) : (
            ""
          ),
      },

      {
        title: "Certificate PDF",
        field: "IsDownloaded",
        render: (rowData: VerifyRow) =>
          !megatronLiteUser &&
          rowData.SharingPermissionName ===
            auditSharingPermission.CertificatePDF &&
          (rowData.CertificationStatus === "Certificated" ||
            rowData.CertificationStatus != "Certificated") ? (
            <PDFTooltip
              title={
                rowData.HasCertificate === true &&
                rowData.CertificationStatus === "Certificated"
                  ? ""
                  : (rowData.HasCertificate === true ||
                      rowData.HasCertificate === false) &&
                    rowData.CertificationStatus != "Certificated"
                  ? VerifyPDFToolTip.CertificatePDFNotCertificated
                  : VerifyPDFToolTip.CertificatePDFCertificatednoFile
              }
            >
              <span >
                <IconButton 
                   disabled={
                    rowData.HasCertificate === true &&
                    rowData.CertificationStatus === "Certificated"
                      ? false
                      : true
                  }
                  onClick={() => {
                 
                    if (rowData.HasCertificate === true) {
                      downloadCertificate(rowData.Id);
                           if(megatronProUser ){
                            trackEvent('Feature_Interaction',{
                            User_Role:"Company user Pro",
                            Tab_Section:"Certificate Tracker",
                            Type:"Button",
                            Feature_Function:"Certificate PDF",
                            UserInput:"Click"})
                          }
                    }
                  }}
                >
                  <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
              </span>
            </PDFTooltip>
          ) : (
            <PDFTooltip
              title={
                megatronLiteUser
                  ? upgradeToProText
                  : rowData.SharingPermissionName ===
                      auditSharingPermission.BasicOnly ||
                    rowData.SharingPermissionName ===
                      auditSharingPermission.CertificateOnly
                  ? VerifyPDFToolTip.BasicOnlyORCertificateOnly
                  : ""
              }
            >
              <span onMouseEnter={()=>{
                if(megatronLiteUser ){trackEvent('Feature_Interaction',{
                  User_Role:"Company user Lite",
                  Tab_Section:"Certificate Tracker",
                  Type:"Button/Hover message",
                  Feature_Function:"Certificate PDF-Pro feature (blocked)",
                  UserInput:"Click/Hover"})

              }}
            }
                style={{ cursor: !megatronLiteUser ? "pointer" : "not-allowed" }}
              >
                <IconButton disabled={true}>
                  <FontAwesomeIcon icon={faFilePdf} />
                </IconButton>
              </span>
            </PDFTooltip>
          ),
      },
]
    return [
      {
        title: "Audit Id",
        field: "Id",
        render: (rowData: VerifyRow) =>
          rowData.SharingPermissionName ===
            auditSharingPermission.CertificateOnly ||
            rowData.SharingPermissionName ===
              auditSharingPermission.CertificatePDF
           ? (
            <Link  onClick={
              () => {if(megatronLiteUser || megatronProUser ){trackEvent('Feature_Interaction',{
                  User_Role:megatronLiteUser?"Company user Lite":megatronProUser?"Company user Pro":"Other User",
                  Tab_Section:"Certificate Tracker",
                  Type:"Button",
                  Feature_Function:"Audit ID (Individual records)",
                  UserInput:"Click"})
              }
                } 
              }
              to={{
                pathname: VerifyUrls.verifyView(rowData.Id),
                state: { backClick: false },
              }}
            >
              {rowData.Id}
            </Link>
          ) :  ""
      },

      { title: "Site", field: "SiteName" },
      {
        title: "Site Code",
        field: "SiteId",
      },
      {
        title: "City",
        field: "City",
        filtering: true,
      },

      {
        title: "Country",
        field: "Country",
        filtering: true,
      },

      {
        title: "Certification Body",
        field: "CertificationBody",
      },

      {
        title: "Standard",
        field: "Standard",
      },
      {
        title: "Grade",
        field: "Grade",
      },
      {
        title: "Issue Date",
        field: "IssueDate",
        type: "date",
      },
      {
        title: "Expiry Date",
        field: "ExpiryDate",
        type: "date",
      },
      {
        title: "Certification Status",
        field: "CertificationStatus",
        render: (rowData: VerifyRow) =>
          rowData.CertificationStatus === "Certificated" ? (
            <label>{rowData.CertificationStatus}</label>
          ) : (
            <label className="colorRed">{rowData.CertificationStatus}</label>
          ),
      },
...((!isCBUser() && !isCBCommercialHorizonUser()) ? columnsNotForCBs:[])
    ];
  };

  export default VerifyTable;